import React from 'react'

export default function NotFound() {
  return (
    <div>
      Oh~! Here is something wrong!
    </div>
  )
}
